import Image from 'next/image';
import React, { createContext, useState } from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import FilterCategoryItem from '../categories/filterCategoryItem';
import Activity_item from './Activity_item';

import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import 'react-tabs/style/react-tabs.css';
import { setModal } from '../../redux/counterSlice';
import GlobalOfferItem from '../tabs/GlobalOfferItem';
import { CollectionCharts } from './CollectionCharts';
import { useEffect } from 'react';
import { Tooltip } from '@mui/material';
import GlobalLendOfferItem from '../tabs/GlobalLendOfferItem';
import useGetGlobalBids from '../../hooks/useGetGlobalBids';
import { useAccount } from 'wagmi';
import useGetOwnedNftCountByCollectionAddress from '../../hooks/useGetOwnedNftCountByCollectionAddress';
import { useGetBidsWithBalance } from '../../hooks/useGetBidsWithBalance';
import { useTokenContract } from '../../helpers/setMarketPlaceAbi';
import { CollectionDao } from './collectionDao/collectionDao';
import { CollectionInfo } from './collection_info';
import { useGetLendignOffersWithBalance } from '../../hooks/useGetLendingOffersWithBalances';

export const collectionItemsTabsContext = createContext(null);

const CollectionTabs = ({ activities, globalBids, offers, collection, globalLendOffers }) => {
  const [itemsTabs, setItemsTabs] = useState(1);
  const [firstRender, setFirstRender] = useState(true);
  // const [categoryItemData, setCategoryItemData] = useState(trendingCategoryData);
  const [globalBidCount, setGlobalBidCount] = useState();
  const [globalTraitBidCount, setGlobalTraitBidCount] = useState();
  const [globalTraitOfferCount, setGlobalTraitOfferCount] = useState();
  const [globalRarityBidCount, setGlobalRarityBidCount] = useState();
  const [globalRarityOfferCount, setGlobalRarityOfferCount] = useState();
  const [offerCount, setOfferCount] = useState();
  const [globalLendOfferCount, setGlobalLendOfferCount] = useState();
  const [globalLendOfferAmount, setGlobalLendOfferAmount] = useState();
  const router = useRouter();
  const pid = collection?.address;
  const collectionAddress = pid;
  const { data: traitBids } = useGetGlobalBids(collectionAddress, true);
  const { data: rarityBids } = useGetGlobalBids(collectionAddress, false, true);
  const dispatch = useDispatch();
  const classes = 'gb2 divide-x-2 divide-white-500';
  const [animation, setAnimation] = useState(false);
  const [lendAnimation, setLendAnimation] = useState(false);
  const { address } = useAccount();
  const { data: ownedNftCount } = useGetOwnedNftCountByCollectionAddress(
    collectionAddress,
    address,
  );
  const tokenContract = useTokenContract(collection?.chain);

  useEffect(() => {
    if (itemsTabs !== 3) {
      setAnimation(false);
    }
    if (itemsTabs !== 5) {
      setLendAnimation(false);
    }
  }, [animation, itemsTabs]);
  useEffect(() => {
    const searchParams = new URLSearchParams(router.asPath.split(/\?/)[1]);
    if (searchParams.get('tab')) setItemsTabs(parseInt(searchParams.get('tab')));
    if (firstRender) return setFirstRender(false);
    setItemsTabs(1);
  }, [pid]);

  const collectionItemsTabs = [
    {
      id: 1,
      text: 'Items',
      icon: 'items',
    },

    {
      id: 2,
      isNotActive: !(ownedNftCount && ownedNftCount > 0),
      text: (
        <div className='flex flex-row items-center'>
          My NFTs
          {ownedNftCount > 0 ? (
            <Tooltip title={`NFTs: ${ownedNftCount}`} placement='top'>
              <div
                className={`py-0.2 mb-[-7px] ml-1 grid -translate-y-1 rounded-full bg-red px-2 py-0.5 text-white`}
              >
                <span className='flex px-1 pt-0.5 text-sm'>{ownedNftCount}</span>
              </div>
            </Tooltip>
          ) : null}
        </div>
      ),
      icon: 'owned',
    },

    {
      id: 3,
      text: 'Activity',
      icon: 'activities',
    },
    {
      id: 4,
      text: (
        <div className='flex flex-row items-center'>
          Global Bids
          {globalBidCount > 0 && offerCount > 0 ? (
            <Tooltip title={`Bidders: ${globalBidCount} Offers: ${offerCount}`}>
              <div
                className={`py-0.2 mb-[-7px] ml-1 grid -translate-y-1 rounded-full bg-red px-2 py-0.5 text-white ${
                  itemsTabs === 4 && classes
                }`}
              >
                <span className='flex px-1 pt-0.5 text-sm'>{globalBidCount}</span>
                {itemsTabs === 4 && <span className='flex px-1 pt-0.5 text-sm'>{offerCount}</span>}
              </div>
            </Tooltip>
          ) : null}
        </div>
      ),
      icon: 'bid',
    },
    {
      id: 5,
      isNotActive: !traitBids || traitBids?.length === 0 || !collection?.traitBidsEnabled,
      text: (
        <div className={'flex flex-row items-center '}>
          Global Trait Bids
          {traitBids?.length > 0 && globalTraitBidCount > 0 && globalTraitOfferCount > 0 ? (
            <Tooltip title={`Bidders: ${traitBids?.length} Offers: ${globalTraitBidCount}`}>
              <div
                className={`py-0.2 mb-[-7px] ml-1 grid -translate-y-1 rounded-full bg-red px-2 py-0.5 text-white ${
                  itemsTabs === 5 && classes
                }`}
              >
                <span className='flex px-1 pt-0.5 text-sm'>{globalTraitBidCount}</span>
                {itemsTabs === 5 && (
                  <span className='flex px-1 pt-0.5 text-sm'>{globalTraitOfferCount}</span>
                )}
              </div>
            </Tooltip>
          ) : null}
        </div>
      ),
      icon: 'bid',
    },
    {
      id: 6,
      isNotActive: !rarityBids || rarityBids?.length === 0 || !collection?.rarityBidsEnabled,
      text: (
        <div className={'flex flex-row items-center '}>
          Global Rarity Bids
          {rarityBids?.length > 0 && globalRarityOfferCount > 0 && globalRarityBidCount > 0 ? (
            <Tooltip title={`Bidders: ${rarityBids?.length} Offers: ${globalRarityBidCount}`}>
              <div
                className={`py-0.2 mb-[-7px] ml-1 grid -translate-y-1 rounded-full bg-red px-2 py-0.5 text-white ${
                  itemsTabs === 6 && classes
                }`}
              >
                <span className='flex px-1 pt-0.5 text-sm'>{globalRarityBidCount}</span>
                {itemsTabs === 6 && (
                  <span className='flex px-1 pt-0.5 text-sm'>{globalRarityOfferCount}</span>
                )}
              </div>
            </Tooltip>
          ) : null}
        </div>
      ),
      icon: 'bid',
    },
    {
      id: 7,
      isNotActive: !collection?.isVerified,
      text: (
        <div className='flex flex-row items-center '>
          Global Lending Offers
          {globalLendOfferCount > 0 ? (
            <Tooltip title={`Bidder:${globalLendOfferCount} Offers: ${globalLendOfferAmount}`}>
              <div
                className={`py-0.2 mb-[-7px] ml-1 grid -translate-y-1 rounded-full bg-red px-2 py-0.5 text-white ${
                  itemsTabs === 7 && classes
                }`}
              >
                <span className='flex px-1 pt-0.5 text-sm'>{globalLendOfferCount}</span>
                {itemsTabs === 7 && (
                  <span className='flex px-1 pt-0.5 text-sm'>{globalLendOfferAmount}</span>
                )}
              </div>
            </Tooltip>
          ) : null}
        </div>
      ),
      icon: 'bid',
    },
    {
      id: 8,
      text: 'Stats',
      icon: 'activities',
    },
    {
      id: 9,
      text: 'Vote',
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='22'
          height='18'
          viewBox='0 0 22 18'
          fill='none'
          className='mr-2'
        >
          <path
            d='M19.9333 4.8942H12.1578V2.04372C12.1578 1.46704 11.68 1 11.0911 1H2.06667C1.47778 1 1 1.46923 1 2.04372V8.67219C1 9.24887 1.47778 9.71591 2.06667 9.71591H4.29111L3.18667 12.8865C3.16222 12.9545 3.18667 13.0291 3.24667 13.0729C3.27556 13.0948 3.31111 13.1058 3.34444 13.1058C3.37778 13.1058 3.41333 13.0948 3.44444 13.0729L8.04667 9.71591H9.84222V12.5664C9.84222 13.1431 10.32 13.6101 10.9089 13.6101H13.9533L18.5556 16.9671C18.5844 16.989 18.62 17 18.6556 17C18.6911 17 18.7244 16.989 18.7533 16.9671C18.8111 16.9254 18.8356 16.8487 18.8133 16.7807L17.7089 13.6101H19.9333C20.5222 13.6101 21 13.1409 21 12.5664V5.93792C21 5.36124 20.5222 4.8942 19.9333 4.8942ZM9.84222 5.93792V9.3892H7.99111C7.95556 9.3892 7.92 9.40016 7.89111 9.42209L3.67556 12.4962L4.68222 9.60847C4.7 9.55804 4.69111 9.50322 4.66 9.45937C4.62889 9.41551 4.57778 9.39139 4.52444 9.39139H2.06667C1.66222 9.39139 1.33333 9.07126 1.33333 8.67658V2.04591C1.33333 1.65123 1.66222 1.3311 2.06667 1.3311H11.0911C11.4956 1.3311 11.8244 1.65123 11.8244 2.04591V4.8964H10.9089C10.32 4.8964 9.84222 5.36563 9.84222 5.94011V5.93792ZM20.6667 12.5664C20.6667 12.9611 20.3378 13.2812 19.9333 13.2812H17.4733C17.42 13.2812 17.3689 13.3075 17.3378 13.3492C17.3067 13.3908 17.2978 13.4479 17.3156 13.4983L18.3222 16.386L14.1067 13.3119C14.0778 13.2922 14.0422 13.279 14.0067 13.279H10.9067C10.5022 13.279 10.1733 12.9589 10.1733 12.5642V5.93573C10.1733 5.54104 10.5022 5.22091 10.9067 5.22091H19.9311C20.3356 5.22091 20.6644 5.54104 20.6644 5.93573V12.5642L20.6667 12.5664ZM8.03111 4.33726C8.03111 4.70782 7.89333 5.06962 7.64222 5.35247C7.52889 5.47965 7.40444 5.59586 7.27111 5.70111C7.14889 5.79759 7.03556 5.89845 6.93333 5.99931C6.83778 6.0936 6.75778 6.20104 6.69333 6.31725C6.63556 6.42469 6.60444 6.56283 6.60444 6.7229V6.89612C6.60444 6.98602 6.52889 7.06057 6.43778 7.06057C6.34667 7.06057 6.27111 6.98602 6.27111 6.89612V6.7229C6.27111 6.50802 6.31333 6.31945 6.39778 6.16157C6.47778 6.01466 6.57778 5.88091 6.69778 5.7647C6.80889 5.65726 6.93111 5.54981 7.06 5.44457C7.17778 5.35028 7.28889 5.24503 7.39111 5.13321C7.58889 4.90955 7.69778 4.6267 7.69778 4.33507C7.69778 3.64657 7.1 3.08524 6.36667 3.08524C5.63333 3.08524 5.07111 3.6071 5.03556 4.27367C5.03111 4.36357 4.95556 4.43155 4.86 4.42935C4.76889 4.42497 4.69778 4.34823 4.70222 4.25613C4.74667 3.41414 5.47778 2.75634 6.36667 2.75634C7.25556 2.75634 8.03111 3.46457 8.03111 4.33507V4.33726ZM6.43778 7.87844C6.26444 7.87844 6.12444 8.01658 6.12444 8.18761C6.12444 8.35864 6.26444 8.49678 6.43778 8.49678C6.61111 8.49678 6.75111 8.35864 6.75111 8.18761C6.75111 8.01658 6.61111 7.87844 6.43778 7.87844ZM6.41778 8.18761C6.41778 8.18761 6.42667 8.16788 6.43778 8.16788C6.44889 8.16788 6.45778 8.17665 6.45778 8.18761C6.45778 8.20954 6.41778 8.20954 6.41778 8.18761ZM17.9089 7.18775L15.0489 11.4591C15.02 11.5029 14.9689 11.5315 14.9156 11.5336H14.9111C14.8578 11.5336 14.8089 11.5095 14.7778 11.4679L13.3244 9.54707C13.2689 9.47472 13.2844 9.37166 13.3578 9.31684C13.4311 9.26203 13.5356 9.27737 13.5911 9.34973L14.9022 11.0841L17.6333 7.00795C17.6844 6.9334 17.7867 6.91147 17.8644 6.9619C17.9422 7.01233 17.9622 7.1132 17.9111 7.18994L17.9089 7.18775Z'
            fill='black'
            stroke='#131740'
            className='stroke-[#131740] dark:stroke-white dark:opacity-75'
          />
        </svg>
      ),
      isNotActive: !collection?.daoEnabled,
    },
    {
      id: 10,
      text: 'Info',
      icon: 'info',
    },
  ];

  const globalBidsWithBalance = useGetBidsWithBalance({
    offers: globalBids,
    chainId: collection?.chain,
    floorPrice: collection?.collectionmetrics?.floorPrice,
    contract: tokenContract,
    sortByPrice: true,
  });

  const globalTraitBidsWithBalance = useGetBidsWithBalance({
    offers: traitBids,
    chainId: collection?.chain,
    floorPrice: collection?.collectionmetrics?.floorPrice,
    contract: tokenContract,
    sortByPrice: true,
  });

  const globalRarityBidsWithBalance = useGetBidsWithBalance({
    offers: rarityBids,
    chainId: collection?.chain,
    floorPrice: collection?.collectionmetrics?.floorPrice,
    contract: tokenContract,
    sortByPrice: true,
  });

  const lendignOffersWithBalance = useGetLendignOffersWithBalance({
    offers: globalLendOffers,
    chainId: collection?.chain,
    contract: tokenContract,
    sortByPrice: true,
  });

  function sumGlobalBidderAmount({ globalBidderArr, statusFilter }) {
    let count = 0;
    globalBidderArr
      .filter((bid) => (statusFilter ? bid.status === statusFilter : true))
      .map(() => {
        count += 1;
      });
    return count;
  }

  function sumGlobalBidAmount({
    globalBidArr,
    statusFilter,
    amountKey = 'globalBidAmount',
    bidderCount = false,
  }) {
    if (!globalBidArr) return 0;
    let count = 0;
    globalBidArr
      .filter((bid) => (statusFilter ? bid.status === statusFilter : true))
      .map((bid) => {
        count += bidderCount ? 1 : Number(bid[amountKey]);
      });
    return count;
  }

  useEffect(() => {
    setGlobalBidCount(
      sumGlobalBidAmount({
        globalBidArr: globalBidsWithBalance,
        statusFilter: 'not processed',
        bidderCount: true,
      }),
    );
    setOfferCount(
      sumGlobalBidAmount({
        globalBidArr: globalBidsWithBalance,
        statusFilter: 'not processed',
      }),
    );
    globalTraitBidsWithBalance &&
      setGlobalTraitBidCount(
        sumGlobalBidAmount({
          globalBidArr: globalTraitBidsWithBalance,
          statusFilter: 'not processed',
          bidderCount: true,
        }),
      );
    globalTraitBidsWithBalance &&
      setGlobalTraitOfferCount(
        sumGlobalBidAmount({
          globalBidArr: globalTraitBidsWithBalance,
          statusFilter: 'not processed',
        }),
      );
    globalRarityBidsWithBalance &&
      setGlobalRarityBidCount(
        sumGlobalBidAmount({
          globalBidArr: globalRarityBidsWithBalance,
          statusFilter: 'not processed',
          bidderCount: true,
        }),
      );
    globalRarityBidsWithBalance &&
      setGlobalRarityOfferCount(
        sumGlobalBidAmount({
          globalBidArr: globalRarityBidsWithBalance,
          statusFilter: 'not processed',
        }),
      );

    lendignOffersWithBalance &&
      setGlobalLendOfferCount(
        sumGlobalBidAmount({
          globalBidArr: globalLendOffers?.filter((item) => !item.isExpired),
          bidderCount: true,
        }),
      );
    lendignOffersWithBalance &&
      setGlobalLendOfferAmount(
        sumGlobalBidAmount({
          globalBidArr: globalLendOffers?.filter((item) => !item.isExpired),
          amountKey: 'amount',
        }),
      );
  }, [globalBidsWithBalance, globalLendOffers, globalTraitBidsWithBalance]);

  return (
    <>
      <collectionItemsTabsContext.Provider value={{ itemsTabs, setItemsTabs }}>
        <section className='relative pb-20'>
          <picture className='pointer-events-none absolute inset-0 -z-10 dark:hidden'>
            {/* <img src="img/gradient_light.jpg" alt="gradient" className="h-full w-full" /> */}
            <Image
              src='/images/gradient_light.jpg'
              alt='gradient'
              className='h-full w-full'
              layout='fill'
            />
          </picture>
          <div className='px-3'>
            {/* <!-- Tabs Nav --> */}
            <Tabs
              selectedIndex={itemsTabs - 1}
              className='tabs'
              // onSelect={(i, l, e) => {
              //   setItemsTabs(i + 1);
              //   router.replace(
              //     {
              //       pathname: router.pathname,
              //       query: { ...router.query, tab: i + 1 },
              //     },
              //     undefined,
              //     { shallow: true },
              //   );
              // }}
            >
              <div className='flex w-full items-center justify-center'>
                <TabList className='nav nav-tabs flex overflow-x-auto overflow-y-hidden border-b border-jacarta-100 dark:border-jacarta-600 md:mb-12 md:items-center'>
                  {collectionItemsTabs.map(({ text, icon, id, isNotActive }, i) => {
                    return (
                      <Tab
                        key={`${i + 1} ${text}`}
                        className={'nav-item' + (isNotActive ? ' hidden' : '')}
                        // className={'nav-item'}
                        value={id}
                        onClick={() => {
                          setItemsTabs(id);
                          router.replace(
                            {
                              pathname: router.pathname,
                              query: { ...router.query, tab: id },
                            },
                            undefined,
                            { shallow: true },
                          );
                        }}
                      >
                        <button
                          className={
                            itemsTabs === id
                              ? 'nav-link active relative flex items-center whitespace-nowrap px-6 py-3 text-jacarta-400 hover:text-jacarta-700 dark:hover:text-white'
                              : 'nav-link relative flex items-center whitespace-nowrap px-6 py-3 text-jacarta-400 hover:text-jacarta-700 dark:hover:text-white'
                          }
                          data-test-id='collectionItemsTab'
                        >
                          {typeof icon === 'string' ? (
                            <svg className='icon icon-items mr-1 h-5 w-5 fill-current'>
                              <use xlinkHref={`/icons.svg#icon-${icon}`} />
                            </svg>
                          ) : (
                            icon
                          )}
                          <span className='font-display text-base font-medium'>{text}</span>
                        </button>
                      </Tab>
                    );
                  })}
                </TabList>
              </div>
              <TabPanel value={1}>
                <div>
                  {collectionAddress && (
                    <FilterCategoryItem
                      chainsDisabled
                      collectionInfo={collection}
                      collection={collectionAddress}
                      raritySetsEnabled={collection?.raritySetsEnabled}
                      tags={collection?.itemLookup?.length > 0 ? collection?.itemLookup : null}
                      disableScroll
                      visibleFloorSweep={true}
                    />
                  )}
                </div>
              </TabPanel>
              {/* {
              <div className={ownedNftCount && ownedNftCount > 0 ? '' : 'hidden'}> */}
              <TabPanel value={2}>
                {collectionAddress &&
                  (ownedNftCount && ownedNftCount > 0 ? (
                    <FilterCategoryItem
                      chainsDisabled
                      collectionInfo={collection}
                      collection={collectionAddress}
                      owner={address}
                      raritySetsEnabled={collection?.raritySetsEnabled}
                      tags={collection?.itemLookup?.length > 0 ? collection?.itemLookup : null}
                      disableScroll
                      visibleFloorSweep={true}
                    />
                  ) : (
                    <div className='text-center'>
                      <p className='text-jacarta-400 dark:text-white'>
                        You don't have any NFTs in this collection.
                      </p>
                    </div>
                  ))}
              </TabPanel>
              {/* </div>
            } */}
              <TabPanel value={3}>
                <div className={'container'}>
                  <Activity_item collectionAddress={collectionAddress} />
                </div>
              </TabPanel>
              <TabPanel value={4}>
                <div className={'container'}>
                  <div
                    className='tab-pane fade show active mt-5'
                    id='offers'
                    role='tabpanel'
                    aria-labelledby='offers-tab'
                  >
                    <div
                      className={
                        'grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5'
                      }
                    >
                      {globalBidsWithBalance?.map((offer, index) => {
                        return (
                          <GlobalOfferItem
                            offer={offer}
                            key={`${index} globalBid ${offer?.issuer}`}
                            isGlobalPage={true}
                          />
                        );
                      })}
                    </div>
                    {globalBidsWithBalance?.length === 0 && (
                      <div className='text-center'>
                        <p className='text-jacarta-400 dark:text-white'>
                          There are no global bids yet.
                        </p>
                        <button
                          className='mt-4 inline-flex items-center text-accent'
                          onClick={() => {
                            dispatch(
                              setModal({
                                key: 'giveGlobalBidModal',
                                data: collectionAddress,
                              }),
                            );
                          }}
                        >
                          <svg className='icon icon-items mr-1 h-5 w-5 fill-current'>
                            <use xlinkHref={`/icons.svg#icon-bid`} />
                          </svg>
                          Make a global bid
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </TabPanel>
              {/* {collection?.traitBidsEnabled && ( */}
              <TabPanel value={5}>
                <div className={'container '}>
                  <div
                    className='tab-pane fade show active mt-5'
                    id='offers'
                    role='tabpanel'
                    aria-labelledby='offers-tab'
                  >
                    <div
                      className={
                        'grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5'
                      }
                    >
                      {collection?.traitBidsEnabled &&
                        globalTraitBidsWithBalance?.map((offer, index) => {
                          return (
                            <GlobalOfferItem
                              offer={offer}
                              key={`${index} globalTraitBid ${offer?.issuer}`}
                              isGlobalPage={true}
                            />
                          );
                        })}
                    </div>
                    {globalTraitBidsWithBalance?.length === 0 && (
                      <div className='text-center'>
                        <p className='text-jacarta-400 dark:text-white'>
                          There are no global trait bids yet.
                        </p>
                        <button
                          className='mt-4 inline-flex items-center text-accent'
                          onClick={() => {
                            if (!collection?.traitBidsEnabled) return;
                            dispatch(
                              setModal({
                                key: 'giveGlobalBidModal',
                                data: collectionAddress,
                                traits: true,
                              }),
                            );
                          }}
                        >
                          <svg className='icon icon-items mr-1 h-5 w-5 fill-current'>
                            <use xlinkHref={`/icons.svg#icon-bid`} />
                          </svg>
                          Make a global trait bid
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </TabPanel>
              <TabPanel value={6}>
                <div className={'container '}>
                  <div
                    className='tab-pane fade show active mt-5'
                    id='offers'
                    role='tabpanel'
                    aria-labelledby='offers-tab'
                  >
                    <div
                      className={
                        'grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5'
                      }
                    >
                      {collection?.rarityBidsEnabled &&
                        globalRarityBidsWithBalance?.map((offer, index) => {
                          return (
                            <GlobalOfferItem
                              offer={offer}
                              key={`${index} globalTraitBid ${offer?.issuer}`}
                              isGlobalPage={true}
                            />
                          );
                        })}
                    </div>
                    {globalRarityBidsWithBalance?.length === 0 && (
                      <div className='text-center'>
                        <p className='text-jacarta-400 dark:text-white'>
                          There are no global rarity bids yet.
                        </p>
                        <button
                          className='mt-4 inline-flex items-center text-accent'
                          onClick={() => {
                            if (!collection?.rarityBidsEnabled) return;
                            dispatch(
                              setModal({
                                key: 'giveGlobalBidModal',
                                data: pid,
                                rarity: true,
                              }),
                            );
                          }}
                        >
                          <svg className='icon icon-items mr-1 h-5 w-5 fill-current'>
                            <use xlinkHref={`/icons.svg#icon-bid`} />
                          </svg>
                          Make a global rarity bid
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </TabPanel>
              {/* )} */}
              {/* {collection?.isVerified && ( */}
              <TabPanel value={7}>
                <div className={'container'}>
                  <div
                    className='tab-pane fade show active mt-5'
                    id='lendOffers'
                    role='tabpanel'
                    aria-labelledby='lendOffers-tab'
                  >
                    <div
                      className={
                        'grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5'
                      }
                    >
                      {lendignOffersWithBalance
                        ?.filter((item) => !item.isExpired)
                        .map((offer, index) => {
                          return (
                            <GlobalLendOfferItem
                              offer={offer}
                              key={`${index} globalLendOffer ${offer?.issuer}`}
                              isGlobalPage={true}
                            />
                          );
                        })}
                    </div>
                    {lendignOffersWithBalance?.filter((item) => !item.isExpired).length === 0 && (
                      <div className='text-center'>
                        <p className='text-jacarta-400 dark:text-white'>
                          There are no global lending offers yet.
                        </p>
                        <button
                          className='mt-4 inline-flex items-center text-accent'
                          onClick={() => {
                            dispatch(
                              setModal({
                                key: 'lendOfferModal',
                                data: {
                                  collection,
                                },
                              }),
                            );
                          }}
                        >
                          <svg className='icon icon-items mr-1 h-5 w-5 fill-current'>
                            <use xlinkHref={`/icons.svg#icon-bid`} />
                          </svg>
                          Make a global lending offer
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </TabPanel>
              {/* )} */}
              <TabPanel value={8}>
                <div className={'container'}>
                  <CollectionCharts collectionAddress={collectionAddress} />
                </div>
              </TabPanel>
              <TabPanel value={9}>
                <div className={'container w-full'}>
                  <CollectionDao daoEnsName={collection?.daoEnsName} />
                </div>
              </TabPanel>
              <TabPanel value={10}>
                <div className={'container'}>
                  <CollectionInfo collection={collection} />
                </div>
              </TabPanel>
            </Tabs>
          </div>
        </section>
      </collectionItemsTabsContext.Provider>
    </>
  );
};

export default CollectionTabs;
